import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { AlertType } from '@/helpers/entities/enums/AlertType';
import { ConsoleLogger } from '@/helpers/entities/classes/logger/ConsoleLogger';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let GraphqlErrorMixin = class GraphqlErrorMixin extends mixins(AlertMixin) {
    hasError() {
        const message = this.$t('graphql.errors.500');
        this.toggleAlert(message, AlertType.error);
    }
    logError(msg) {
        const logger = new ConsoleLogger();
        logger.error(msg);
    }
    formCallbackError(message) {
        this.hasError();
        this.logError(message);
    }
};
GraphqlErrorMixin = __decorate([
    Component
], GraphqlErrorMixin);
export default GraphqlErrorMixin;
